<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <h1 class="text-center pad-top--xl pad-bottom--xl z-up text-white marg-bottom--none">
                Loyalty Scheme
            </h1>
        </div>
        <div class="grid-container pad-bottom pad-top">
            <div class="grid-x grid-padding-x">
                <div class="cell small-4">
                    <div class="card fix-height pad">
                        <p class="text-center">
                            <img width="51" src="../../../static/images/loyalty/shopping-bag.png" alt="" />
                        </p>
                        <h3 class="text-heavy pad-top pad-bottom text-blue text-center">Buy</h3>
                        <p class="text-center">
                            we value your business and award loyalty points for every purchase
                        </p>
                    </div>
                </div>

                <div class="cell small-4">
                    <div class="card fix-height pad">
                        <p class="text-center">
                            <img width="60" src="../../../static/images/loyalty/investment.png" alt="" />
                        </p>
                        <h3 class="text-heavy pad-top pad-bottom text-blue text-center">Earn</h3>
                        <p class="text-center">
                            every pound spent earns one loyalty point
                        </p>
                    </div>
                </div>

                <div class="cell small-4">
                    <div class="card fix-height pad">
                        <p class="text-center">
                            <img width="60" src="../../../static/images/loyalty/target.png" alt="" />
                        </p>
                        <h3 class="text-heavy pad-top pad-bottom text-blue text-center">Redeem</h3>
                        <p class="text-center">
                            for every 100 points you will receive one pound discount off your
                            next purchase
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg--img wash heavy bg--home-stats">
            <div class="grid-x grid-padding-x z-up pad-top pad-bottom">
                <div class="cell small-12 medium-4">
                    <p class="text-center">
                        <img src="../../../static/images/product-number.png" alt="" />
                    </p>
                    <p class="text-white text-center">Number of products</p>
                    <h4 class="text-white text-center">4,455</h4>
                </div>
                <div class="cell small-12 medium-4">
                    <p class="text-center">
                        <img src="../../../static/images/customisation-number.png" alt="" />
                    </p>
                    <p class="text-white text-center">Number of customisations to date</p>
                    <h4 class="text-white text-center">23,443</h4>
                </div>
                <div class="cell small-12 medium-4">
                    <p class="text-center">
                        <img src="../../../static/images/satisfaction-number.png" alt="" />
                    </p>
                    <p class="text-white text-center">Satisfaction rate</p>
                    <h4 class="text-white text-center">96%</h4>
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <h5 class="text-center text-blue pad-top--xl pad-bottom--small">What customers say</h5>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-bottom--xl">
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-1.png" alt="" />
                </p>
                <h5 class="text-center">
                    Albert Parker / London
                </h5>
                <p class="text-center pad-left pad-right">
                    The Customised Clothing website was very easy to use, I placed my order online
                    and actually received it a day earlier than expected. Great quality clothing
                    and service! I would highly recommend.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-2.png" alt="" />
                </p>
                <h5 class="text-center">
                    Tom Pollas / Germany
                </h5>
                <p class="text-center pad-left pad-right">
                    I had an urgent requirement for some printed t-shirts for an event, Customised
                    Clothing delivered the t-shirts on time and the quality of print was fantastic.
                    I will definitely be ordering from them again.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import axios from '../../axios';

export default {
    name: 'Contact',
    metaInfo() {
        return {
            title: 'Loyalty Scheme',
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: 'Loyalty Scheme for our customers' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/loyalty-scheme' },
            ],
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
    data() {
        return {
            contact: {
                name: '',
                email: '',
                telephone: '',
                message: '',
            },
        };
    },
    methods: {
        sendForm(event) {
            event.preventDefault();
            axios.post('/Contacts/newContactForm.json', this.contact)
                .then((response) => {
                    // eslint-disable-next-line
                    console.log(response);
                });
        },
    },
};
</script>




<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'Loyalty Scheme',
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/LoyaltyScheme.vue